import {
  cn,
  twVariants
} from "./chunk-LJ5F4WFH.js";

// src/Skeleton/SkeletonCircle.tsx
import React from "react";
var styles = twVariants({
  slots: {
    root: ["animate-pulse rounded-full bg-surface-medium"]
  },
  variants: {
    size: {
      tiny: {
        root: "size-[14px]"
      },
      xs: {
        root: "size-6"
      },
      sm: {
        root: "size-8"
      },
      md: {
        root: "size-10"
      },
      lg: {
        root: "size-13"
      },
      xl: {
        root: "size-[72px]"
      },
      huge: {
        root: "size-[100px]"
      }
    }
  }
});
var SkeletonCircle = React.forwardRef(
  ({ className, size = "md", ...props }, ref) => {
    const { root } = styles({ size });
    return /* @__PURE__ */ React.createElement("div", { ref, className: cn(root(), className), ...props });
  }
);
SkeletonCircle.displayName = "SkeletonCircle";

// src/Skeleton/SkeletonRectangle.tsx
import React2 from "react";
var styles2 = twVariants({
  slots: {
    root: ["h-3 w-full animate-pulse bg-surface-medium"]
  },
  variants: {
    size: {
      sm: {
        root: "h-8"
      },
      md: {
        root: "h-10"
      },
      lg: {
        root: "h-13"
      }
    },
    rounded: {
      default: {
        root: "rounded"
      },
      full: {
        root: "rounded-full"
      }
    }
  }
});
var SkeletonRectangle = React2.forwardRef(({ className, size, rounded = "default", ...props }, ref) => {
  const { root } = styles2({ size, rounded });
  return /* @__PURE__ */ React2.createElement("div", { ref, className: cn(root(), className), ...props });
});
SkeletonRectangle.displayName = "SkeletonRectangle";

export {
  SkeletonCircle,
  SkeletonRectangle
};
//# sourceMappingURL=chunk-XWL6HH3U.js.map